import React from 'react'
import { NavLink, Link } from 'react-router-dom'
import classNames from 'classnames'

import Button from '../Button'

import AccountMenu from './AccountMenu'

import styles from './Navbar.module.css'

export default function Navbar({ bannerActive }) {
  return (
    <header
      className={classNames(styles.header, bannerActive && styles.bannerActive)}
    >
      <div className={styles.brandWrapper}>
        <Link to="/" className={styles.brandWrapper}>
          <Brand />
        </Link>
      </div>
      <div className={styles.tabs}>
        <NavLink
          className={styles.tab}
          activeClassName={styles.active}
          to="/databases"
        >
          Data
        </NavLink>
        <NavLink
          className={styles.tab}
          activeClassName={styles.active}
          to="/actions"
        >
          Actions
        </NavLink>
      </div>
      <div className={styles.rightNav}>
        <Button color="white" to="/actions/new" icon="add">
          Create Action
        </Button>
        <AccountMenu />
      </div>
    </header>
  )
}

export const Brand = function NavbarBrand({ className }) {
  return (
    <span className={classNames(styles.brand, className)}>EasyButton.io</span>
  )
}
